import { fetchTeamsBulk } from '@atlassian/search-client/teams';

export async function fetchAndUpdateTeamNames(
	cloudId: string | undefined,
	teamIds: string[],
	nodeIdMap: Record<string, string | null>,
	setTeamNames: React.Dispatch<React.SetStateAction<Record<string, string | null>>>,
	logError: (error: unknown) => void,
): Promise<void> {
	if (cloudId && teamIds.length > 0) {
		try {
			const { teams } = await fetchTeamsBulk({ siteId: cloudId, teamIds });
			const newTeamNames: Record<string, string> = {};
			for (let i = 0; i < teams.length; i++) {
				const team = teams[i];
				newTeamNames[team.id] = team.displayName;
			}
			setTeamNames((prevTeamNames) => {
				const updatedTeamNames = { ...prevTeamNames };
				for (const [nodeId, teamId] of Object.entries(nodeIdMap)) {
					updatedTeamNames[nodeId] = teamId ? newTeamNames[teamId] : null;
				}
				return updatedTeamNames;
			});
			return;
		} catch (e) {
			logError(e);
		}
	}
	// If fetching teams fails, we still want to update the team names to null
	setTeamNames((prevTeamNames) => {
		const updatedTeamNames = { ...prevTeamNames };
		for (const [nodeId] of Object.entries(nodeIdMap)) {
			updatedTeamNames[nodeId] = null;
		}
		return updatedTeamNames;
	});
}
